export const getRandomNumber = (num: number = 6) => {
  var code = ''
  for (var i = 0; i < num; i++) {
    code += parseInt((Math.random() * 10).toString())
  }
  return code
}
